export const palette = {
  ample: {
    0: "#f1f7fd",
    1: "#e0eef9",
    2: "#c8e1f5",
    3: "#a1cfef",
    4: "#75b4e5",
    5: "#5498dd",
    6: "#3778c3",
    7: "#366abf",
    8: "#32569b",
    9: "#2d4a7b",
    10: "#1f2e4c",
  },
  neutral: {
    0: "#ffffff",
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a",
  },
  warmNeutral: {
    0: "#fffdfa",
    50: "#faf7f0",
    100: "#f4efe4",
    200: "#e9dfcf",
    300: "#d6c6ae",
    400: "#bda88d",
    500: "#9e876d",
    600: "#806a54",
    700: "#665241",
    800: "#45372b",
    900: "#2a2119",
  },
  navy: {
    50: "#eef5ff",
    100: "#dbeafe",
    200: "#bfd8ff",
    300: "#91bbff",
    400: "#5f94f2",
    500: "#356dcc",
    600: "#2557b8",
    700: "#1f4594",
    800: "#1e386f",
    900: "#172846",
  },
  sage: {
    50: "#eef9f1",
    100: "#d8f0df",
    200: "#b5dfc2",
    300: "#86c69b",
    400: "#5daa78",
    500: "#3f8d5d",
    600: "#2f714a",
    700: "#285b3f",
    800: "#234934",
    900: "#1e3c2c",
  },
  clinicalBlue: {
    50: "#f0f7ff",
    100: "#e2effd",
    200: "#c7e0fa",
    300: "#a2ccf4",
    400: "#78b1eb",
    500: "#5595de",
    600: "#3778c3",
    700: "#2f61a0",
    800: "#294f80",
    900: "#243f63",
  },
  sky: {
    25: "#eff8ff",
    50: "#f0f9ff",
    100: "#e0f2fe",
    200: "#bae6fd",
    300: "#7dd3fc",
    400: "#38bdf8",
    500: "#0ea5e9",
    600: "#0284c7",
    700: "#0369a1",
    800: "#075985",
    900: "#0c4a6e",
    950: "#1e3a5f",
  },
  teal: {
    50: "#f0fdfa",
    100: "#ccfbf1",
    200: "#99f6e4",
    300: "#5eead4",
    400: "#2dd4bf",
    500: "#14b8a6",
    550: "#0d9488",
    600: "#0f766e",
    700: "#115e59",
    800: "#134e4a",
    900: "#042f2e",
  },
  blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#172554",
  },
  emerald: {
    50: "#ecfdf5",
    100: "#d1fae5",
    200: "#a7f3d0",
    300: "#6ee7b7",
    400: "#34d399",
    500: "#10b981",
    600: "#059669",
    700: "#047857",
    800: "#065f46",
    900: "#064e3b",
  },
  amber: {
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    900: "#78350f",
  },
  rose: {
    50: "#fff1f2",
    100: "#ffe4e6",
    200: "#fecdd3",
    300: "#fda4af",
    400: "#fb7185",
    500: "#f43f5e",
    600: "#e11d48",
    700: "#be123c",
    800: "#9f1239",
    900: "#881337",
  },
} as const;

export type Palette = typeof palette;
